import React, { useState, useEffect } from "react";
import axiosConfig from "../../Service/AxiosConfig";
import { PopupModal } from "../PopupModal/PopupModal";
import loader from "../Animations/Sandy Loading.gif";
import { useDispatch, useSelector } from "react-redux";
import { setProfile } from "../../redux/ProfileSlice";

const Profile = () => {
  const [readOnly, setReadOnly] = useState(true);
  const [popupType, setPopupType] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [nameError, setNameError] = useState("");
  const [mobileError, setMobileError] = useState("");

  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: "",
    mobileno: "",
    city: "",
    state: "",
    address: "",
  });

  const user_id = localStorage.getItem("user_id");
  const profileData = useSelector((state) => state.profile.profile);

  const getUser = async () => {
    setLoading(true);
    try {
      const response = await axiosConfig.get(`/accounts/users/${user_id}/`);
      const data = {
        name: response?.data?.name || "",
        mobileno: response?.data?.mobileno || "",
        city: response?.data?.city || "",
        state: response?.data?.state || "",
        address: response?.data?.address || "",
      };
      setFormData(data);
      dispatch(setProfile(data));

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleAddMore = () => {
    setReadOnly(false);
  };

  const handleSubmit = async () => {
    setNameError("");
    setLoading(true);
    if (formData.name.trim() === "") {
      setNameError("Please enter a name");
      setLoading(false);
      return;
    }

    try {
      await axiosConfig.patch(`/accounts/profile_update/${user_id}/`, formData);
      setReadOnly(true);
      setPopupType("success");
      setMessage("Profile updated successfully!");
      setError("");
      setLoading(false);
    } catch (error) {
      console.log(error);
      setPopupType("error");
      setError(error?.response?.data?.error || "Something went wrong");
      setLoading(false);
    }
  };
  useEffect(() => {
    if (profileData && profileData.name) {
      setFormData(profileData);
    } else {
      getUser();
    }
  }, []);

  if (loading)
    return (
      <div>
        <img src={loader} alt="loader" />
      </div>
    );

  return (
    <>
      <div className="patient-dashboard-child">
        <div className="profile">
          <h3>Profile</h3>
          <button className="book-service-btn">Book Service</button>
        </div>

        <div className="form-container">
          <div className="form-group">
            <label
              className={`form-label ${readOnly ? "view-mode-label" : ""}`}
            >
              Full Name
            </label>
            <sup style={{ color: "red" }}>*</sup>
            <input
              type="text"
              required
              value={formData?.name}
              disabled={readOnly}
              placeholder="Full Name"
              onChange={(e) => {
                const value = e.target.value;
                const updated = { ...formData, name: value };
                setFormData(updated);
                dispatch(setProfile(updated));
              }}
              className={`form-control ${readOnly ? "view-mode-text" : ""}`}
            />
            {nameError && <p className="error-text">{nameError}</p>}
          </div>
          <div className="form-group">
            <label
              className={`form-label ${readOnly ? "view-mode-label" : ""}`}
            >
              Mobile Number
            </label>

            <input
              type="text"
              placeholder="Mobile Number"
              disabled={readOnly}
              value={formData.mobileno}
              maxLength={10}
              onChange={(e) => {
                const value = e.target.value;
                if (!/^\d*$/.test(value)) {
                  setMobileError("Only digits are allowed");
                  return;
                }
                const updated = { ...formData, mobileno: value };
                setFormData(updated);
                dispatch(setProfile(updated));
                if (value.length === 10) {
                  setMobileError("");
                } else {
                  setMobileError("Enter 10 digit mobile number");
                }
              }}
              onBlur={() => {
                if (formData.mobileno.length !== 10) {
                  setMobileError("Enter 10 digit mobile number");
                }
              }}
              className={`form-control ${readOnly ? "view-mode-text" : ""}`}
            />

            {mobileError && !readOnly && (
              <p className="error-text">{mobileError}</p>
            )}
          </div>

          <div className="form-group">
            <label
              className={`form-label ${readOnly ? "view-mode-label" : ""}`}
            >
              City
            </label>
            <input
              type="text"
              placeholder="City"
              disabled={readOnly}
              value={formData?.city}
              onChange={(e) => {
                const updated = { ...formData, city: e.target.value };
                setFormData(updated);
                dispatch(setProfile(updated));
              }}
              className={`form-control ${readOnly ? "view-mode-text" : ""}`}
            />
          </div>
          {!readOnly && (
            <>
              <div className="form-group">
                <label
                  className={`form-label ${readOnly ? "view-mode-label" : ""}`}
                >
                  State
                </label>
                <input
                  type="text"
                  value={formData.state}
                  disabled={readOnly}
                  placeholder="State"
                  onChange={(e) => {
                    const updated = { ...formData, state: e.target.value };
                    setFormData(updated);
                    dispatch(setProfile(updated));
                  }}
                  className={`form-control ${readOnly ? "view-mode-text" : ""}`}
                />
              </div>
              <div className="form-group span-address">
                <label
                  className={`form-label ${readOnly ? "view-mode-label" : ""}`}
                >
                  Addres
                </label>
                <input
                  type="text"
                  value={formData.address}
                  disabled={readOnly}
                  placeholder="Address..."
                  onChange={(e) => {
                    const updated = { ...formData, address: e.target.value };
                    setFormData(updated);
                    dispatch(setProfile(updated));
                  }}
                  className={`form-control ${readOnly ? "view-mode-text" : ""}`}
                />
              </div>
            </>
          )}
        </div>
        {readOnly && (
          <div className="btn-container">
            <button className="add-more-btn" onClick={handleAddMore}>
              Add More
            </button>
          </div>
        )}
        {!readOnly && (
          <div className="btn-container">
            <button className="save-btn" onClick={handleSubmit}>
              Save
            </button>
          </div>
        )}
      </div>
      {popupType && (
        <PopupModal
          setpopupType={setPopupType}
          popupType={popupType}
          Navigation=""
          error={error}
          Message={message}
          setMessage={setMessage}
        />
      )}
    </>
  );
};

export { Profile };
